import { BaseTabInterface, BaseAbsenceTypeEnum } from 'base';

export const AbsenceTabsConst: Array<BaseTabInterface> = [
  { title: 'all', id: BaseAbsenceTypeEnum.all },
  {
    title: 'work.holiday',
    id: BaseAbsenceTypeEnum.holiday,
    data: {
      badge: '0',
    },
  },
  {
    title: 'work.illness',
    id: BaseAbsenceTypeEnum.illness,
    data: {
      badge: '0',
    },
  },
  {
    title: 'work.offline',
    id: BaseAbsenceTypeEnum.offline,
    data: {
      badge: '0',
    },
  },
  {
    title: 'work.free_shift',
    id: BaseAbsenceTypeEnum.freeShift,
    data: {
      badge: '0',
    },
  },
  {
    title: 'work.time_off_compensation',
    id: BaseAbsenceTypeEnum.timeOffCompensation,
    data: {
      badge: '0',
    },
  },
  {
    title: 'work.unexcused_absence',
    id: BaseAbsenceTypeEnum.unexcused,
    data: {
      badge: '0',
    },
  },
  {
    title: 'work.other',
    id: BaseAbsenceTypeEnum.other,
    data: {
      badge: '0',
    },
  },
];
